import { Switch } from 'antd';

type PermissionsSwitchProps = {
  uuid: string;
  permissionKey: string;
  label: string;
  checked?: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
};

const PermissionsSwitch = ({
  uuid,
  permissionKey,
  label,
  checked = false,
  disabled,
  onChange,
}: PermissionsSwitchProps) => (
  <div className="w-full flex flex-col gap-0.5 items-center">
    <label htmlFor={`${permissionKey}-switch-${uuid}`} className="text-xsm">
      {label}
    </label>
    <Switch
      id={`${permissionKey}-switch-${uuid}`}
      checked={checked}
      defaultChecked={checked}
      disabled={disabled}
      onChange={onChange}
      className="bg-[rgba(0,0,0,0.45)]"
    />
  </div>
);

export default PermissionsSwitch;
